export const FCT_Cache = new Map();
//# sourceMappingURL=cache.js.map